module.exports = __webpack_public_path__ + "img/quote-icon.f69f6f7e.svg";